import _ from 'lodash';

// copied from original repository - storm/nautiqus
// nautiqus\frontend\src\main\webapp\frontend\src\services\decoders.js
//
// decodes incoming data by filling up object referenced by ___jsonidref field
export const jsonIdDecode = (data: any, refLookup: any): any => {
  if (data === undefined || data === null) {
    return null;
  }
  if (_.isArray(data)) {
    const resultArray = [],
      len = data.length;
    for (let i = 0; i < len; ++i) {
      resultArray.push(jsonIdDecode(data[i], refLookup));
    }
    return resultArray;
  }
  if (_.isObject(data)) {
    if ((data as any).__jsonidref) {
      // our object refers to something previously defined
      return refLookup[(data as any).__jsonidref];
    }

    const resultObject = data;
    for (const property in data) {
      if (
        Object.prototype.hasOwnProperty.call(data, property) &&
        property !== '__jsonid'
      ) {
        (resultObject as any)[property] = jsonIdDecode(
          (data as any)[property],
          refLookup,
        );
      }
    }

    if ((data as any).__jsonid) {
      // fill in the lookup
      refLookup[(data as any).__jsonid.__jsonidref] = resultObject;
    }
    return resultObject;
  }
  return data;
};
